import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '@/assets/themeThree/CalenderBlue.png'


const _hoisted_1 = { class: "dayImage" }
const _hoisted_2 = { class: "dateText" }
const _hoisted_3 = { class: "dayTitle" }
const _hoisted_4 = {
  class: "valueText",
  style: {"color":"#38a8fa"}
}
const _hoisted_5 = { class: "dayTitle" }
const _hoisted_6 = {
  class: "valueText",
  style: {"color":"#d390ff"}
}
const _hoisted_7 = { class: "dayImage2" }
const _hoisted_8 = {
  class: "dateText",
  style: {"font-size":"12px"}
}
const _hoisted_9 = {
  class: "dayTitle",
  style: {"font-size":"12px"}
}
const _hoisted_10 = { style: {"padding-left":"10px","color":"#ffdcfb"} }
const _hoisted_11 = { class: "right-texts" }
const _hoisted_12 = {
  key: 0,
  style: {"color":"#0484ff"}
}
const _hoisted_13 = {
  key: 1,
  style: {"color":"#36d836"}
}
const _hoisted_14 = {
  key: 2,
  style: {"color":"#ff0000"}
}
const _hoisted_15 = {
  key: 3,
  style: {"color":"#ff0000"}
}
const _hoisted_16 = { class: "dayTitle" }
const _hoisted_17 = {
  key: 0,
  style: {"color":"#0484ff"}
}
const _hoisted_18 = {
  key: 1,
  style: {"color":"#36d836"}
}
const _hoisted_19 = {
  key: 2,
  style: {"color":"#ff0000"}
}
const _hoisted_20 = {
  key: 3,
  style: {"color":"#ff0000"}
}

import { checkDate, dayFormat, formatCurrency, } from '@/utils/commonFunction';
import { getAmountSum } from '@/view/components/supportFunction';
import { PropType, } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'cashBackHistoryCard',
  props: {
    dayCount: {
        type: Number,
    },
    dayList: {
        type: Array as PropType<(any)[]>,
        default: () => []
    },
    createTime: {
        type: String,
        default: () => ""
    },
    availableAmount: {
        type: Number,
        default: () => 0
    },
    title: {
        type: String,
        default: () => ""
    },
    totalAmount: {
        type: Number,
        default: () => 0
    },
    activityStatus: {
        type: Number
    },
    istodayClaimed: {
        type: Boolean,
        default: () => false
    },
    isShowDetails: {
        type: Boolean,
        default: () => true
    },
    givenAmount: {
        type: Number,
        default: () => 0
    },
},
  setup(__props) {

const props = __props


return (_ctx: any,_cache: any) => {
  const _component_van_col = _resolveComponent("van-col")!
  const _component_van_row = _resolveComponent("van-row")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['cardContainer', !__props.isShowDetails && 'cardContainer2'])
  }, [
    (__props.isShowDetails)
      ? (_openBlock(), _createBlock(_component_van_row, {
          key: 0,
          style: _normalizeStyle({ borderBottom: __props.isShowDetails ? '#80808070 dashed 1px' : '' })
        }, {
          default: _withCtx(() => [
            _createVNode(_component_van_col, {
              span: "6",
              class: "dayColumn"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_1, [
                  _cache[0] || (_cache[0] = _createElementVNode("img", {
                    src: _imports_0,
                    alt: ""
                  }, null, -1)),
                  _createElementVNode("div", _hoisted_2, _toDisplayString(__props.createTime?.split(' ')[0]), 1)
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_van_col, {
              span: "8",
              class: "topRow",
              style: {"margin":"10px 0","border-left":"2px solid #80808070"}
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_3, _toDisplayString(__props.title), 1),
                _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(formatCurrency)(__props.totalAmount)), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_van_col, {
              span: "8",
              class: "topRow",
              style: {"margin":"10px 0"}
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t('activity.cashBackTotal')), 1),
                _createElementVNode("div", _hoisted_6, _toDisplayString(__props.dayList ? _unref(formatCurrency)(_unref(getAmountSum)(__props.dayList)) : _unref(formatCurrency)(0)), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["style"]))
      : _createCommentVNode("", true),
    (!__props.isShowDetails)
      ? (_openBlock(), _createBlock(_component_van_row, {
          key: 1,
          style: _normalizeStyle({ borderBottom: __props.isShowDetails ? '#80808070 dashed 2px' : '' })
        }, {
          default: _withCtx(() => [
            _createVNode(_component_van_col, {
              span: "6",
              class: "dayColumn"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_7, [
                  _cache[1] || (_cache[1] = _createElementVNode("img", {
                    src: _imports_0,
                    alt: ""
                  }, null, -1)),
                  _createElementVNode("div", _hoisted_8, _toDisplayString(__props.createTime?.split(' ')[0]), 1)
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_van_col, {
              span: "12",
              class: "topRow",
              style: {"margin":"10px 0"}
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_9, [
                  _createTextVNode(_toDisplayString(_ctx.$t('activity.givenAmount')) + " : ", 1),
                  _createElementVNode("span", _hoisted_10, _toDisplayString(_unref(formatCurrency)(__props.givenAmount)), 1)
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_van_col, {
              span: "6",
              class: "dayColumn"
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_11, [
                  (props.activityStatus == 0)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_12, _toDisplayString(_ctx.$t('activityStatus.pending')), 1))
                    : (props.activityStatus == 1)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_13, _toDisplayString(_ctx.$t('activityStatus.completed')), 1))
                      : (props.activityStatus == 2)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_14, _toDisplayString(_ctx.$t('activityStatus.noRewards')), 1))
                        : (props.activityStatus == 3)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_15, _toDisplayString(_ctx.$t('activity.overdue')), 1))
                          : _createCommentVNode("", true)
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["style"]))
      : _createCommentVNode("", true),
    (__props.isShowDetails)
      ? (_openBlock(), _createBlock(_component_van_row, {
          key: 2,
          style: {"margin-top":"10px","display":"flex","justify-content":"center"},
          justify: "space-between"
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.dayList, (i, index) => {
              return (_openBlock(), _createBlock(_component_van_col, {
                span: "4",
                key: index
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", {
                    class: "dayCard",
                    style: _normalizeStyle({ color: _unref(checkDate)(i.date) == 0 && __props.istodayClaimed ? '#36d836' : _unref(checkDate)(i.date) <= 0 ? 'gray' : '' })
                  }, [
                    _createElementVNode("div", _hoisted_16, _toDisplayString((_unref(dayFormat)(i.date, 0))), 1),
                    _createElementVNode("div", null, _toDisplayString(_unref(formatCurrency)(i.amount)), 1)
                  ], 4)
                ]),
                _: 2
              }, 1024))
            }), 128)),
            _createTextVNode(_toDisplayString() + " ", 1),
            (__props.dayList?.length <= 0 || !__props.dayList)
              ? (_openBlock(), _createBlock(_component_van_col, { key: 0 }, {
                  default: _withCtx(() => [
                    (props.activityStatus == 0)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_17, _toDisplayString(_ctx.$t('activityStatus.pending')), 1))
                      : (props.activityStatus == 1)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_18, _toDisplayString(_ctx.$t('activityStatus.completed')), 1))
                        : (props.activityStatus == 2)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_19, _toDisplayString(_ctx.$t('activityStatus.noRewards')), 1))
                          : (props.activityStatus == 3)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_20, _toDisplayString(_ctx.$t('activity.overdue')), 1))
                            : _createCommentVNode("", true)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ], 2))
}
}

})